/**
 * LanguageLevelMapper
 *
 * Maps numeric language proficiency levels (1-7) to their short codes
 * for Amplitude analytics tracking.
 *
 * ⚠️ IMPORTANT: This mapper is intended for AMPLITUDE TRACKING ONLY.
 *
 * For UI display, use i18n translations instead:
 * - t('options.languageLevel.short.{level}') for short codes
 * - t('general.language.levelOptions.{level}') for full labels
 *
 * Why this distinction?
 * - Amplitude analytics need consistent, language-agnostic identifiers
 * - UI needs translated, user-facing text that changes with locale
 * - This mapper ensures analytics stability across languages
 */
class LanguageLevelMapper {
  private levelMap: Record<string, string> = {
    '1': 'A1',
    '2': 'A2',
    '3': 'B1',
    '4': 'B2',
    '5': 'C1',
    '6': 'C2',
    '7': 'Muttersprache',
  }
  public mapLevel(levelCode: string | number | null): string | null {
    if (!levelCode) return null
    return this.levelMap[levelCode] || null
  }
}

export default new LanguageLevelMapper()
